import { createSelector } from 'reselect';
import { getKaMetlhaFuneralCover } from './index';
import { getPurchasePersonalDetailsForm } from './personalDetails';

export const getUploadDocuments = createSelector(
    getKaMetlhaFuneralCover,
    (kaMetlhaFuneralCover) => kaMetlhaFuneralCover.uploadDocuments
);
export const getUploadDocumentForm = createSelector(getUploadDocuments, (uploadDocuments) => uploadDocuments.form);


export const getDocumentsArray = createSelector(getUploadDocumentForm, (uploadDocuments) => {
    return uploadDocuments
});

const inputFieldLabels = {
    certifiedCopyOfId: 'Your ID',
    incomeProof: 'Proof Of Income Statement',
    addressProof: 'Proof Of Address',
    bankStatement: 'Bank Statement',
};



export const getUploadDocumentsSummary = createSelector(
    getPurchasePersonalDetailsForm,
    getUploadDocumentForm,
    ({ employementType }, uploadDocumentForm) => {
        const { incomeProof, ...filteredDocument } = uploadDocumentForm;
        return Object.keys(employementType?.value === 'Employed' ? uploadDocumentForm : filteredDocument)
            ?.flatMap((item) => ({
                label: inputFieldLabels[item],
                value: uploadDocumentForm[item]?.fileName ?? '-',
            }))
            .filter(({ label }) => label);
    }
);
